import React, { useEffect, useState } from 'react'
import DynamicActionBar from '../../Common/DynamicActionBar'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ACTIONS } from '../../redux/actions'
import { HeadersPath } from '../../Utils/ScreenPath'
import { ErrorToast } from '../../Common/Toast'
import { Api } from '../../Service/api'
import { QuestionReporyBox } from '../../Component/PaperHistory/SubscriptionBox'
import { NotDataFound } from '../NotFound'
import QuestionReportModel from '../../Common/QuestionReport'
import QuestionReportDetail from '../../Common/QuestionReportDetail'

const QuestionReport = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loader = useSelector((state) => state?.Loader?.Loader);

    const [isReportModelOpen, setIsReportModelOpen] = useState(false)
    const [questionReport, setQuestionReport] = useState([])
    const [queReportData, setQueReportData] = useState({})
    const handleBackClick = () => {
        navigate(-1)
    }

    const _getReportQuestions = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                limit: 1000,
                offset: 1
            }
            const { data } = await Api.getQuestionsReport(params)
            const res = JSON.parse(data)
            if (res?.status === 200) {
                setQuestionReport(res?.data)
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleReportDetailsModel = async (que) => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                limit: 1000,
                offset: 1
            }
            let id = que.id
            const { data } = await Api.getQuestionsReportById(params, id)
            const res = JSON.parse(data)
            if (res?.status === 200) {
                setQueReportData(res?.data?.[0]);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }

        setIsReportModelOpen(true)
    }

    useEffect(() => {
        _getReportQuestions()
        dispatch(ACTIONS.getHeaderPath(HeadersPath.Profile))
    }, [])

    return (
        <div>
            <DynamicActionBar
                showArrowLeft
                backButtonLabel={"Reported Questions"}
                onBackClick={handleBackClick}
            />

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 py-4">
                {questionReport.map((que) => (
                    <QuestionReporyBox key={que.id} questionData={que} handleReportDetailsModel={handleReportDetailsModel} />
                ))}
            </div>
            {questionReport.length === 0 && loader === false && (
                NotDataFound("No Questions Reported")
            )}

            <QuestionReportDetail
                isModelOpen={isReportModelOpen}
                setIsPurchaseModelOpen={setIsReportModelOpen}
                queReportData={queReportData}
            />
        </div>
    )
}

export default QuestionReport